import React, {
  useEffect,
  useRef,
  useCallback,
  useMemo,
  useState,
} from "react";
import { TreeView } from "devextreme-react/tree-view";
// import { navigation } from "../../app-navigation";
import { useNavigation } from "../../contexts/navigation";
import { useScreenSize } from "../../utils/media-query";
import "./SideNavigationMenu.scss";
import * as events from "devextreme/events";
import "remixicon/fonts/remixicon.css";
import { Autocomplete, Button, Tooltip } from "devextreme-react";
import { useAuth } from "../../contexts/auth";

export default function SideNavigationMenu(props) {
  const { children, selectedItemChanged, openMenu, compactMode, onMenuReady } =
    props;

  const { user } = useAuth();
  const { isLarge } = useScreenSize();
  useEffect(() => {
    if (compactMode) {
      setSearchValue("");
    }
  }, [compactMode]);

  function normalizePath() {
    const navigation = user?.userAuth || [];
    return navigation.map((item) => ({
      ...item,
      expanded: isLarge,
      path: item.path && !/^\//.test(item.path) ? `/${item.path}` : item.path,
    }));
  }

  const items = useMemo(normalizePath, [user, isLarge]);

  const {
    navigationData: { currentPath },
  } = useNavigation();

  const treeViewRef = useRef(null);
  const wrapperRef = useRef();
  const [searchValue, setSearchValue] = useState("");

  const getWrapperRef = useCallback(
    (element) => {
      const prevElement = wrapperRef.current;
      if (prevElement) {
        events.off(prevElement, "dxclick");
      }

      wrapperRef.current = element;
      events.on(element, "dxclick", (e) => {
        openMenu(e);
        setSearchValue("");
      });
    },
    [openMenu],
  );

  useEffect(() => {
    const treeView = treeViewRef.current && treeViewRef.current.instance;
    if (!treeView) {
      return;
    }

    if (currentPath !== undefined) {
      treeView.selectItem(currentPath);
      treeView.expandItem(currentPath);
    }

    if (compactMode) {
      treeView.collapseAll();
    }
  }, [currentPath, compactMode]);
  const itemRender = (item) => {
    return (
      <div
        className="treeview-item-content"
        // title={compactMode ? item.text : ""}
      >
        {compactMode && (
          <Tooltip
            target={`.${item.icon}`}
            showEvent="mouseenter"
            hideEvent="mouseleave"
            position="right"
            // visible={compactMode}
            contentRender={() => item.text}
          />
        )}

        <i className={`${item.icon} custom-icon`}></i>
        {/* Conditionally render the text based on compact mode */}
        {!compactMode && <span className="custom-text">{item.text}</span>}
      </div>
    );
  };
  // Handle search input change
  const handleSearchValueChanged = (e) => {
    setSearchValue(e.value);
  };

  const filterItemsRecursively = (item, searchValue) => {
    const normalizedSearchValue = (searchValue || "").toLowerCase();

    if (item.text.toLowerCase().includes(normalizedSearchValue)) {
      return { ...item };
    }
    if (item.items && item.items.length) {
      const filteredSubItems = item.items
        .map((subItem) => filterItemsRecursively(subItem, searchValue))
        .filter(Boolean);

      if (filteredSubItems.length) {
        return {
          ...item,
          items: filteredSubItems,
        };
      }
    }
    return false;
  };

  const filteredItems = useMemo(() => {
    // console.log("Items : ", );
    return items
      .map((item) => filterItemsRecursively(item, searchValue))
      .filter(Boolean);
  }, [items, searchValue]);

  return (
    <>
      <div
        className={"dx-swatch-additional side-navigation-menu"}
        ref={getWrapperRef}
      >
        {children}
        {compactMode && (
          <>
            {/* <Tooltip
              target={`.search-icon`}
              showEvent="mouseenter"
              hideEvent="mouseleave"
              position="right"
              // visible={compactMode}
              contentRender={() => "Search"}
            />
            <div className="search-icon">
              <i className="ri-search-line"></i>
            </div> */}
          </>
        )}
        {!compactMode && (
          <div className="search-box">
            <i className="ri-search-line"></i>
            <Autocomplete
              placeholder="Search modules"
              stylingMode="outlined"
              showClearButton={true}
              // displayExpr={(item) => item}
              searchExpr="name"
              className={"custom-search-box"}
              value={searchValue}
              onValueChanged={handleSearchValueChanged}
            />
          </div>
        )}
        <div className={"menu-container"}>
          <TreeView
            ref={treeViewRef}
            // items={items}
            items={filteredItems}
            keyExpr={"path"}
            selectionMode={"single"}
            focusStateEnabled={false}
            expandEvent={"click"}
            onItemClick={(e) => {
              selectedItemChanged(e);
              setSearchValue("");
            }}
            onContentReady={onMenuReady}
            itemRender={itemRender}
            width={"100%"}
            value={searchValue}
            onValueChanged={handleSearchValueChanged}
          />
        </div>
      </div>
    </>
  );
}
